module.exports = __webpack_public_path__ + "img/hopital-sacre-coeur.c34a09b7.png";